import {
  NgbDatepickerConfig,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';

export const NGB_DATEPICKER_CONFIG: Partial<NgbDatepickerConfig> = {
  minDate: { year: 1910, month: 1, day: 1 },
  maxDate: {
    year: new Date().getUTCFullYear(),
    month: new Date().getUTCMonth() + 1,
    day: new Date().getUTCDate(),
  },
  navigation: 'select',
};

export const PASSWORD_REGEXP =
  /(?=.*[0-9])(?=.*[!"#$%&()*+,-./:;<=>?@^_`{|}~])[a-zA-Z0-9!"#$%&()*+,-./:;<=>?@^_`{|}~]{8,}/;

export const EMAIL_REGEXP = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';

export const MODAL_OPTIONS: NgbModalOptions = {
  animation: true,
  backdrop: 'static',
  size: 'fullscreen',
  scrollable: true,
  modalDialogClass: 'p-lg-10',
};

export enum endPoints {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  AUTH = 'auth',
  LOGIN = 'iniciar-sesion',
  USER = 'usuario',
  ME = 'me',
  RESET_PASSWORD = 'reiniciar-clave',
  UPDATE_PASSWORD = 'actualizar-clave',
  CHANGE_PASSWORD = 'cambiar-clave',
  CONFIRM_USER = 'confirmar-usuario',
  INFORMATION = 'intercambio-informacion',
  GENERAL_DATA = 'datos-generales',
  FIND = 'buscar',
  RESUME = 'resumen',
  CITIZEN = 'ciudadano',
  ORGANIZATIONS = 'entidades',
  ORGANIZATION = 'entidad',
  UPDATE = 'actualizar',
  BONDING = 'vinculacion',
  LINKS = 'vinculaciones',
  CITIZEN_DOCUMENT = 'documentos-ciudadano',
  DOCUMENT = 'documento',
  CATALOGUE = 'catalogo',
  ORGANIZATION_TYPE = 'tipo-entidad',
  REGISTER = 'registrar',
  HISTORY_EVENT = 'historico-evento',
  CONTACT_DATA = 'datos-contacto',
}

export enum ErrorsEnum {
  INTERNAL_ERROR = 1,
  WRONG_PASSWORD_USER = 5,
  REQUIRED_RESET_PASSWORD = 6,
  FIRST_LOGIN = 7,
  USER_NO_REQUIRE_CHANGE_PASSWORD = 8,
  NEW_PASSWORD_CANT_BE_THE_SAME = 9,
  PASSWORD_TEMP_EXPIRED = 17,
  INVALID_CODE = 19,
  TRY_LIMIT = 11,
  WRONG_CREDENTIALS = 12,
  DATA_NO_RECEIVED = 13,
  NO_REGISTER = 14,
  ERROR_REQUEST_SERVICE = 15,
  USER_BLOCKED = 115,
  INACTIVE_USER = 116,
}

export const VU_PARAMETER_ID = 'VU_INTEGRACION_JCE' as const;

export enum InformationType {
  MESSAGE = 1,
  DOCUMENTS = 2,
}

export const CHART_COLORS = [
  '#0f145b',
  '#48b1bf',
  '#0095E8',
  '#50CD89',
  '#FFC700',
  '#7E8299',
  '#20c997',
  '#0dcaf0',
  '#F1416C',
];

export const FORMAT_END_DATE = 'yyyy-MM-ddT23:59:59';
export const FORMAT_START_DATE = 'yyyy-MM-ddT00:00:00';
export const TOTAL_ITEMS_PER_PAGE = 10;
export const UNHANDLE_ERROR_MESSAGE =
  'En este momento no podemos atender su solicitud, por favor vuelva a intentarlo más tarde.' as const;
export const MOTIVO_CANTIDAD_MAXIMA_OTP = 18 as const;
export const USER_CREDENTIALS = 'userCredentials' as const;
export const SOLICITUD_ALTA_USUARIO = 1 as const

//ROLES
export const ROLES = {
  1: 'Administrador',
  2: 'Administrador Centro Capitado',
  3: 'Líder médico Promoción y Prevención',
  4: 'Operador Empresa',
  5: 'Medico',
  6: 'Enfermero'
} as const;

export type RoleIds = keyof typeof ROLES;
export type RoleNames = typeof ROLES[RoleIds];
